// Get authentication token
export const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Get user role
export const getRole = () => {
  return localStorage.getItem('role');
};

// Clear all auth data
export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
};

// Check if authenticated
export const isAuthenticated = () => {
  return !!getAuthToken();
};